import React from 'react'
import './Footer.scss'

const Footer = () => {
    return (
        <div className='footer dark'>
            <p>Copyright &copy; 2024 | <a href="https://github.com/Son-Tr" target='_blank' rel="noopener noreferrer">
                Son Tran
            </a>
            </p>
        </div>
    )
}

export default Footer